/**
 * The one paging predicate for the Received/Sent recognition lists (overview-rebuild-pr4-plan.md "One
 * predicate, not two"). Before this PR the same expression lived twice, inline inside
 * `loadNextPageReceived`/`loadNextPageSent` — a "Load more" button needs
 * the identical check to hide itself once a tab's last page is already loaded, and restating it at
 * render would leave two copies free to drift, silently hiding a live button or showing a dead one.
 * Used in BOTH places now: the button's render condition and the pagination callback's own guard.
 *
 * feed-failed-page-plan.md (Option C): takes the tab's own HELD ROW COUNT rather than deriving "how
 * much has been loaded" from `filter.limit * (filter.page + 1)`. `filter.page` means "the page last
 * REQUESTED", not "the page last successfully loaded" — those diverge the moment a page request
 * fails, since nothing rolls `page` back. `hasMore` itself has nothing to do with retrying a failed
 * page, though — that job belongs to `receivedRecognitionsLoadedPages`/`sentRecognitionsLoadedPages`
 * (RecognitionState.interface.tsx), advanced only on a successful load. This predicate answers a
 * narrower question: given the rows this tab is currently holding, does the server have any more.
 *
 * @param rowCount - the tab's own held row count (`receivedRecognitions.length` /
 *   `sentRecognitions.length`), never a page/limit-derived count.
 * @param total - the tab's total row count, as returned by the API.
 * @returns true while more rows exist on the server than are currently held.
 */
export const hasMore = (rowCount: number, total: number): boolean => rowCount < total;
